import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["DashboardResult"] */ "/app/src/features/components/DashboardResult.tsx");
